<template>
  <default-layout :breadcrumbs="breadcrumbs">
    <view-skeleton>
      <transfer />
    </view-skeleton>
  </default-layout>
</template>

<script>
import DefaultLayout from '@/layouts/default';
import DefaultHeadMixin from '@/mixins/defaultHead';
import Transfer from '@/components/coins-usage/transfer';
import ViewSkeleton from '@/components/utils/view-skeleton';

export default {
  name: 'index',
  mixins: [DefaultHeadMixin],
  components: {
    DefaultLayout,
    Transfer,
    ViewSkeleton,
  },
  computed: {
    breadcrumbs() {
      const currentName = this.$t('home.sidebarMenu.transferCoin');
      return [
        {
          text: this.$t('breadcrumb.homepage'),
          to: '/',
        },
        {
          text: currentName,
          to: this.$router.currentRoute.path,
        },
      ];
    },
  },
};
</script>
